export const oneprojectActions = {
    SET_ONEPROJECT: 'SET_ONEPROJECT'
};

const oneProjectReducer = (state, action) => {
    switch (action.type) {
        case oneprojectActions.SET_ONEPROJECT:
            return {
                ...state,
                oneproject: action.oneproject,
            };
        default:
            return {
                state
            };
    }
};

export default oneProjectReducer;